<template>
  <v-container grid-list-md>
    <v-layout v-if="isAdmin" row wrap>
      <v-flex d-flex xs12 sm6 md4 lg3>
        <div class="text-xs-center title font-weight-light">
          <v-btn dark fab large color="blue" :to="{ path: '/settings/mobile-types'}">
            <v-icon dark>perm_device_information</v-icon>
          </v-btn><br />
          Mobile Types
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4 lg3>
        <div class="text-xs-center title font-weight-light">
          <v-btn fab dark large color="blue" :to="{ path: '/settings/committees'}">
            <v-icon dark>group</v-icon>
          </v-btn><br />
          Committees
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4 lg3>
        <div class="text-xs-center title font-weight-light">
          <v-btn fab dark large color="blue" :to="{ path: '/settings/liasons'}">
            <v-icon dark>gavel</v-icon>
          </v-btn><br />
          Liasons and Officers
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4 lg3>
        <div class="text-xs-center title font-weight-light">
          <v-btn fab dark large color="blue" :to="{ path: '/settings/certificates'}">
            <v-icon dark>image</v-icon>
          </v-btn><br />
          Certificates
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4 lg3>
        <div class="text-xs-center title font-weight-light">
          <v-btn fab dark large color="blue" :to="{ path: '/settings/badges'}">
            <v-icon dark>badge</v-icon>
          </v-btn><br />
          Badges
        </div>
      </v-flex>
      <!-- <v-flex d-flex xs12 md6>
        <div class="text-xs-center">
          <v-btn fab dark large color="purple">
            <v-icon dark>android</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex d-flex xs12 md6>
        <div class="text-xs-center">
          <v-btn fab dark large color="purple">
            <v-icon dark>android</v-icon>
          </v-btn>
        </div>
      </v-flex> -->
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12 class="title">You do not have access to settings.</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    // myId: this.$store.state.user.id,
    isAdmin: false
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id
  },

  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/settings/List.vue